/* @flow */

import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './BlankWithDesktopSideBarTemplate.style';

import Container from 'src/shared/app/base/component/container/Container';
import ContentWithSidebar from 'src/shared/app/base/component/template/component/ContentWithSidebar';
import Branding from './component/Branding';
import NotificationPortal from 'src/shared/app/notification/component/NotificationPortal';

const useStyles = createUseThemeStyles(styles);

type Props = {
  Switch: React.ComponentType<any>,
};

const BlankWithDesktopSideBarTemplate = ({ Switch }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  /*
   |------------------------------------------------------------------------------
   | Elements
   |------------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <Container>
        <Branding layoutClass={classes.branding} />

        <NotificationPortal />

        <ContentWithSidebar small noSurvey hideNewTopicButton>
          <Switch layoutClass={classes.main} />
        </ContentWithSidebar>
      </Container>
    </div>
  );
};

export default React.memo<Props>(BlankWithDesktopSideBarTemplate);
